<template>
  <div class="c-question-item">
    <div class="c-content">
      <div class="c-content__inner">
        <div style="padding: 20px">
          <div>
            <span class="c-badge">{{ knowledgeName }}</span>
          </div>
          <div class="c-q-content">
            <div v-katexHtml="content"></div>
            <img
              :src="image.source"
              v-for="image in getImgList(data)"
              :key="image.source"
              alt=""
            />
          </div>

          <div class="c-q-option">
            <div v-for="(oitem, oindex) in option" :key="oindex">
              <p>{{ oitem.key }} :</p>
              <p v-katexHtml="oitem.content"></p>
            </div>
          </div>
        </div>
        <footer>
          <div class="c-left">
            <span class="c-type">题型:{{ typeText }} </span>
            <span> 难度:{{ difficulty }}</span>
          </div>
          <div class="c-right">
            <button
              v-if="!isPad"
              class="i-feedback"
              @click="visibleFeedback = true"
            >
              反馈
            </button>
            <button class="i-analyze" @click="visibleAnalyze = !visibleAnalyze">
              {{ visibleAnalyze ? "关闭" : "查看" }}解析
            </button>
          </div>
        </footer>
      </div>
    </div>

    <div class="c-analyze" v-show="visibleAnalyze">
      <div class="c-analyze__inner">
        <!-- <div class="c-analyze__option">
          <div v-for="(oitem, oindex) in option" :key="oindex">
            <p>{{oitem.key}} : </p>
            <p v-katexHtml="oitem.content"></p>
          </div>
        </div> -->
        <div class="c-item">
          <span class="c-label">正确答案：</span>
          <span class="is-green" v-katexHtml="answer"></span>
        </div>
        <div class="c-item">
          <span class="c-label">文字解析：</span>
          <div class="c-item__content">
            <p
              v-for="item in analyzeList"
              :key="item.analyze_uuid"
              v-katexHtml="item.content"
            ></p>
          </div>
        </div>
        <div v-if="video" class="c-item">
          <span class="c-label">视频解析：</span>
          <div class="c-item__content">
            <div class="badge-video" @click="visibleVideo = true">
              {{ duration }}
            </div>
          </div>
          <div class="t-mask" v-show="visibleVideo">
            <div class="video-container">
              <i class="el-icon-close" @click="visibleVideo = false"></i>
              <y-player :videoUrl="video" ref="videoPlayer" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <Feedback
      :data="questionId"
      v-if="visibleFeedback"
      @close="visibleFeedback = false"
    />
  </div>
</template>

<script>
// <span v-if="question_info.question_title_uuid == 1">阅读题</span>
//       <span v-else-if="question_info.question_type == 1 &&
//        question_info.show_type == 100">选择题</span>
//       <span v-else-if="question_info.question_type == 2 &&
//        question_info.show_type == 101">多选题</span>
//       <span v-else-if="question_info.question_type == 3 &&
//        question_info.show_type == 102">填空题</span>
//       <span v-else-if="question_info.question_type == 3 &&
//        question_info.show_type == 103">判断题</span>
//       <span v-else-if="question_info.question_type == 6 &&
//        question_info.show_type == 112">选词填空题</span>
import _ from 'lodash';
import yPlayer from '@/components/y-player.vue';
import Feedback from './feedback.vue';

export default {
  components: { yPlayer, Feedback },
  name: 'QuestionItem',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      visibleVideo: false,
      visibleAnalyze: false,
      visibleFeedback: false,
      duration: '00:00',
      isPad: this.$route.query.spad,
    };
  },
  computed: {
    // 题型
    type() {
      // _${_.get(this.data, 'show_type')}
      return `${_.get(this.data, 'question_type')}`;
    },
    typeText() {
      const typeMap = {
        1: '选择题',
        2: '多选题',
        3: '填空题',
        // 3_103: '判断题',
        6: '选词填空题',
      };
      return typeMap[this.type];
    },
    knowledgeName() {
      return _.get(this.data, 'knowledge[0].knowledge_name');
    },
    content() {
      return _.get(this.data, 'body.content');
    },
    difficulty() {
      return _.get(this.data, 'teacher_diff');
    },
    answer() {
      return _.get(this.data, 'answer[0][0].content');
    },
    analyzeList() {
      return _.get(this.data, 'analyze[0]');
    },
    video() {
      return _.get(this.data, 'analyze[0][0].video_data[0].source_url');
    },
    questionId() {
      return _.get(this.data, 'question_uuid');
    },
    option() {
      return _.get(this.data, 'option');
    },
  },
  watch: {
    video: {
      immediate: true,
      handler(v) {
        if (v) {
          console.log(v);
          const audio = new Audio(v);
          audio.addEventListener('loadedmetadata', () => {
            this.duration = this.formatMS(audio.duration);
          });
        }
      },
    },
  },
  methods: {
    getImgList(item) {
      return _.get(item, 'body.img_data', []);
    },
    formatMS(s) {
      if (!s) {
        return '00:00';
      }
      const m = `${String(Math.floor(s / 60)).padStart(2, '0')}`;
      const seconds = `${String(Math.ceil(s % 60)).padStart(2, '0')}`;
      return `${m}:${seconds}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.c-question-item {
  margin-bottom: 18px;
  .c-type {
    padding-right: 100px;
  }
  .c-content {
    width: 100%;
    background: rgba(118, 194, 255, 0.14);
    border-radius: 12px;
    padding: 3px;
    box-sizing: border-box;
    &__inner {
      background: #ffffff;
      box-shadow: 1px 1px 6px 0px rgba(177, 162, 237, 0.32);
      border-radius: 12px;
      width: 100%;
      footer {
        background-image: url("~@/views/pt/images/footer.png");
        width: 100%;
        height: 48px;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        box-sizing: border-box;
        display: flex;
        font-size: 14px;
        color: rgba(90, 94, 102, 1);
        button {
          color: rgba(25, 137, 250, 1);
          background-size: 15px;
          padding-left: 23px;
          background-repeat: no-repeat;
          background-position: left center;
          & + button {
            margin-left: 24px;
          }
          &.i-feedback {
            background-image: url("~@/views/pt/images/feedback.png");
          }
          &.i-analyze {
            background-image: url("~@/views/pt/images/analyze.png");
          }
        }
      }
    }
  }
  .c-badge {
    padding: 4px 12px;
    background: #f0f2f5;
    border-radius: 3px;
    border: 1px solid #d7dfec;
    color: rgba(90, 94, 102, 1);
    font-size: 13px;
  }
  .c-q-content {
    margin-top: 16px;
    color: rgba(17, 31, 44, 1);
    font-size: 15px;
  }
  .c-q-option {
    div {
      display: inline-block;
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      margin: 0 20px;
      margin-top: 20px;
      p {
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .c-analyze {
    padding: 0 4px 4px 4px;
    width: 668px;
    max-width: 100%;
    background: rgba(118, 194, 255, 0.14);
    border-radius: 0px 0px 12px 12px;
    box-sizing: border-box;
    margin: 0 auto;
    &__option {
      div {
        display: inline-block;
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        margin: 0 20px;
        margin-top: 20px;
        p {
          display: inline-block;
          margin-right: 5px;
        }
      }
    }
    &__inner {
      background: #fff;
      background: #ffffff;
      box-shadow: 1px 1px 6px 0px rgba(177, 162, 237, 0.32);
      border-radius: 0px 0px 12px 12px;
      padding: 0 20px;
      box-sizing: border-box;
    }
  }
  .c-item {
    padding: 20px 0;
    display: flex;
    font-size: 15px;
    box-sizing: border-box;
    &:not(:last-of-type) {
      border-bottom: 1px dashed rgba(220, 225, 235, 1);
    }
    &__content {
      flex: 1;
    }
    .c-label {
      font-weight: 500;
      color: #000;
      width: 100px;
    }
    .is-green {
      color: rgba(103, 194, 58, 1);
    }
    p {
      color: rgba(96, 98, 102, 1);
    }
  }
  .badge-video {
    width: 84px;
    height: 28px;
    line-height: 28px;
    background-color: #ffa82d;
    border-radius: 14px;
    padding-left: 33px;
    background-image: url("~@/views/pt/images/class_video.png");
    background-size: 24px 24px;
    background-position: left 3px center;
    background-repeat: no-repeat;
    color: #fff;
    font-size: 14px;
    box-sizing: border-box;
  }
  .t-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    .video-container {
      width: 600px;
      height: 400px;
      background: #fff;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
      position: relative;
    }
    .el-icon-close {
      position: absolute;
      font-size: 30px;
      top: 10px;
      right: 10px;
    }
  }
}
</style>
